<template>

<div class="table-container">
  <div class="loginMessage" v-if="showLoginMessage">Please login to be able to get or save data at server.</div>
  <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <thead>
        <tr>
            <th>Show</th>
            <th>Name</th>
            <th>Actions</th>
            <th>Date</th>
            <th>Comment</th>
            <th>Light, W/m2</th>
            <th>T, C</th>
            <th>Isc, A</th>
            <th>Uoc, V</th>
            <th>FF, %</th>
            <th>Wmpp, W</th>
            <th>Impp, A</th>
            <th>Umpp, V</th>
            <th>Rs, Ohm</th>
            <th class="has-text-white has-background-primary-dark">STC Wmpp, W</th>
            <th class="has-text-info has-background-info-light">STC Isc, A</th>
            <th class="has-text-info has-background-info-light">STC Uoc, V</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sample in samples" :key="sample.id">
            <td> 
                <input type="checkbox" class="" :id="sample.id"  :value="sample.id" v-model="selectedSamples" @change="showSample(sample)"> 
            </td>
            <td>{{ sample.name }}</td>
            <td>
                <button v-if="sample.saved" class="button" @click="deleteSample(sample.id)" >Delete</button>
                <button v-if="!sample.saved" class="button is-warning" @click="saveSample(sample)" >Save</button>
            </td>
            <td>{{ (new Date(sample.date)).toLocaleDateString() }} {{ (new Date(sample.date)).toLocaleTimeString() }}</td>
            <td>{{ sample.comment }}</td>
            <td>{{ sample.light }} 
                <!-- {{getLightChanges(sample.lights)}} -->
            </td>
            <td>{{ sample.temperature }}</td>
            <td>{{ sample.isc }}</td>
            <td>{{ sample.uoc }}</td>
            <td>{{ sample.ff }}</td>
            <td><strong>{{ sample.wmpp }}</strong></td>
            <td>{{ sample.impp }}</td>
            <td>{{ sample.umpp }}</td>

            <td>{{ sample.rs }}</td>

            <td class="has-text-white has-background-primary-dark is-size-5">{{ sample.stcWmpp > 100 ? Math.round(sample.stcWmpp) : sample.stcWmpp }}</td>
            <td class="has-text-info has-background-info-light">{{ sample.stcIsc }}</td>
            <td class="has-text-info has-background-info-light">{{ sample.stcUoc }}</td>
        </tr>
      </tbody>
  </table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "SampleGrid",   
    async created () {
        if(this.$store.state.accessToken){
            this.showLoginMessage = false;            
        }
        else{
            this.showLoginMessage = true;
        }
        await this.loadSamples();
    },
    data() {
        return {
            selectedSamples: [],
            showLoginMessage: false,
        }
    },    
    methods: {
        ...mapActions(['getSamplesAction', 'getSampleDataAction', 'updateSampleAction', 'deleteSampleAction']),
        async loadSamples() {
            await this.getSamplesAction();
        },
        getLightChanges(lights)
        {
            if(!lights  || lights.length<2)
            return "";

            let output = "[";
            let l1 = lights[0];
            for(var i = 1; i<lights.length; i++)
            {
                const l = lights[i];
                const x = Math.round( l * 100 / l1) - 100;
                if(x>0)
                {
                    output += '+' + x;
                }
                else
                {
                    output += x;
                }
                l1 = l;
                if(i<lights.length-1)
                {
                    output +=",";
                }
            }
            output +="]%";
            return output;

        },
        showSample : async function(sample){
            // /* eslint-disable no-debugger */
            // debugger;
            if(!this.selectedSamples.includes(sample.id)){
                this.$emit("hide", sample.id);
                return;
            }
            if(!sample.sampleData || sample.sampleData.length === 0){
                await this.getSampleDataAction(sample.id);                
            }
            //TODO: display data
            //console.log(sample.sampleData);
            this.$emit("show",sample.id);

            //TODO: hide sample
        },
        saveSample: async function(sample){
            await this.updateSampleAction(sample);
        },
        deleteSample : async function(sampleId){
            if(confirm("Are you sure to delete this sample?"))
                await this.deleteSampleAction(sampleId);
        },
    },
    computed: {
        ...mapState(['samples','selectedFolder']),        
    },
    watch: {
            'selectedFolder' :{
                immediate: true,
                handler(newValue,oldValue) { 
                    if(newValue != oldValue)
                    {
                        this.getSamplesAction();
                    }
                }
            },
            'samples' : {
                immediate: true,
                handler(newValue,oldValue) {  
                    var sample = undefined;      
                    if(newValue && newValue.length > 0)
                    {
                        if(oldValue && oldValue.length >0 )
                        {
                            if(oldValue.length > newValue.length)
                            {
                                //hide deleted element
                                sample = oldValue.filter(x => !newValue.map(y=>y.id).includes(x.id))[0];
                                if(this.selectedSamples.includes(sample.id))
                                {
                                    var index = this.selectedSamples.indexOf(sample.id);
                                    this.selectedSamples.splice(index,1);  
                                    this.$emit("hide", sample.id);                                
                                }
                                return;
                            }
                            else{
                                sample = newValue[0]; 
                            }

                        }
                        else 
                        {
                            sample = newValue[0];                            
                        }
                        if(sample.sampleData && sample.sampleData.length >0 && !this.selectedSamples.includes(sample.id))
                        {
                            //show element
                            this.selectedSamples.push(sample.id);       
                            this.$emit("show",sample.id);                     
                        }
                        
                    }
                }
            }
        },
}
</script>

<style>

</style>